export default {
  banner: {
    success: {
      title: 'Votre situation est à jour au {date}, veuillez la mettre à jour si nécessaire.',
      description: 'Renseignez les informations manquantes et augmentez la précision des informations ci-dessous ainsi que la pertinence de notre conseil.',
    },
    warning: {
      title: 'Fiabilisez votre indicateur avant de continuer',
      description: 'Veuillez mettre à jour votre situation fiscale de façon détaillée pour accéder au parcours de conseil.'
    },
    buttonLabel: 'Fiabiliser mes informations'
  },
  modal: {
    title: 'Vos données sont-elles à jour ?',
    content: 'Les préconisations qui seront réalisées dans le cadre de ce parcours de conseil seront basées sur les éléments de votre situation fiscale mise à jour sur LCL Mon Patrimoine le {date} pour l\'année {year}. En continuant, je confirme que ces données sont à jour.',
    confirmLabel: 'Continuer',
    cancelLabel: 'Mettre à jour les données',
  },
  sections: {
    taxationBalance: {
      title: 'Bilan de votre fiscalité :',
    },
    taxationBenefits: {
      title: 'Consommation de vos avantages fiscaux :',
    },
    indicatorsSavingsLevers: {
      title: 'Les leviers permettant d\'investir pour optimiser votre fiscalité :'
    }
  }
}
